import React from 'react';
import { Container, Header, Button, FormContainer, Actions } from './styles';

export default function CrudForm({
    title,
    onSubmit,
    onCancel,
    isSubmitting,
    children
}) {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e);
    };

    return (
        <Container>
            <Header>
                <h1>{title}</h1>
            </Header>

            <FormContainer onSubmit={handleSubmit}>
                {children}

                <Actions style={{ justifyContent: 'flex-end', marginTop: '16px' }}>
                    <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
                        Cancelar
                    </Button>
                    <Button type="submit" variant="primary" disabled={isSubmitting}>
                        {isSubmitting ? 'Salvando...' : 'Salvar'}
                    </Button>
                </Actions>
            </FormContainer>
        </Container>
    );
}
